<section class="bg-gradient-to-b from-gray-50 to-white md:p-32 md:pt-16 py-12">
  <div
    class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto bg-white rounded-3xl shadow-strong overflow-hidden"
  >
    <div
      class="col-span-1 md:border-r-2 border-gray-100 py-10 md:p-10 px-6 md:px-10 order-1 animate-fadeInUp"
    >
      <!--  <h1 class="text-primary text-2xl font-bold mb-5">Preguntas frecuentes:</h1>
      <div class="bg-white p-1 mt-2" *ngFor="let thread of options; let i = index">

        <div (click)="toggleThread(i)"
          class="flex justify-between bg-gray-100 p-2 pl-5 pr-5 rounded-xl cursor-pointer">
          <span class="text-primary font-medium">{{thread.name}}</span>
          <div *ngIf="threadSelected != i">
            <svg width="15" height="15" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.42 11.045H11.35V18.29H7.64V11.045H0.57V7.685H7.64V0.439998H11.35V7.685H18.42V11.045Z"
                fill="#2A2A2A" />
            </svg>
          </div>
          <div *ngIf="threadSelected == i">
            <svg width="15" height="15" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.57 7.685H18.42V11.045H0.57V7.685Z" fill="#2A2A2A" />
            </svg>
          </div>
        </div>

        <div *ngIf="threadSelected === i" class="p-5 w-full">
          <div *ngFor="let item of options[threadSelected].faqs" class="w-full">
            <button (click)="item.open = !item.open"
              class="flex justify-between items-start text-left text-primary text-sm font-semibold w-full my-5">
              <div class="flex-grow">{{item.question}}</div>
              <div class="flex items-end space-x-2">
                <svg *ngIf="!item.open" (click)="item.open = true" width="15" height="15" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
                <svg *ngIf="item.open" (click)="item.open = false" width="15" height="15" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </button>
            <div class="p-1 pt-0 text-sm" [class.hidden]="!item.open" [innerHTML]="getAnswerHtml(item.answer)">
            </div>
          </div>
        </div>

      </div> -->

      <div class="inline-block mb-6">
        <h1 class="text-3xl md:text-4xl font-bold text-primary mb-2">
          Contacto
        </h1>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full"
        ></div>
      </div>

      <p class="text-gray-700 mb-8 text-lg">
        Si tiene alguna pregunta o inquietud sobre nuestros servicios, no dude
        en contactarnos a través de nuestros canales:
      </p>

      <!-- Ventas -->
      <div
        class="bg-gradient-to-br from-primary/5 to-transparent p-6 rounded-2xl mb-6 border-l-4 border-primary hover:shadow-medium transition-all duration-300"
      >
        <h3 class="text-primary font-bold text-xl mb-3 flex items-center">
          <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
            />
          </svg>
          Ventas
        </h3>
        <div class="space-y-2 ml-8">
         <!--  <p class="flex items-center text-gray-700">
            <span class="font-medium mr-2">Tel:</span> 4582-6340
          </p> -->
          <p class="flex items-center">
            <span class="font-medium mr-2 text-gray-700">Wsp:</span>
            <a
              href="https://wa.me/5491168786533"
              target="_blank"
              class="text-secondary hover:text-primary font-medium transition-colors duration-300 hover:underline"
            >
              +54 9 11 6878-6533
            </a>
          </p>
          <p class="flex items-center">
            <span class="font-medium mr-2 text-gray-700">Mail:</span>
            <a
              href="mailto:ventas.hogar@everfull.com.ar"
              class="text-secondary hover:text-primary font-medium transition-colors duration-300 hover:underline"
            >
              ventas.hogar@everfull.com.ar
            </a>
          </p>
        </div>
      </div>

      <!-- Atención al Cliente -->
      <div
        class="bg-gradient-to-br from-secondary/5 to-transparent p-6 rounded-2xl mb-6 border-l-4 border-secondary hover:shadow-medium transition-all duration-300"
      >
        <h3 class="text-primary font-bold text-xl mb-3 flex items-center">
          <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z"
              clip-rule="evenodd"
            />
          </svg>
          Atención al Cliente
        </h3>
        <div class="space-y-2 ml-8">
          <!-- <p class="flex items-center text-gray-700">
            <span class="font-medium mr-2">Tel:</span> 4582-6340
          </p> -->
          <p class="flex items-center">
            <span class="font-medium mr-2 text-gray-700">Wsp:</span>
            <a
              href="https://wa.me/5491126144219"
              target="_blank"
              class="text-secondary hover:text-primary font-medium transition-colors duration-300 hover:underline"
            >
              +54 9 11 2614-4219
            </a>
          </p>
          <p class="flex items-center">
            <span class="font-medium mr-2 text-gray-700">Mail:</span>
            <a
              href="mailto:atencion.hogar@everfull.com.ar"
              class="text-secondary hover:text-primary font-medium transition-colors duration-300 hover:underline"
            >
              atencion.hogar@everfull.com.ar
            </a>
          </p>
        </div>
      </div>

      <!-- Administración -->
      <div
        class="bg-gradient-to-br from-primary/5 to-transparent p-6 rounded-2xl mb-6 border-l-4 border-primary hover:shadow-medium transition-all duration-300"
      >
        <h3 class="text-primary font-bold text-xl mb-3 flex items-center">
          <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
            <path
              fill-rule="evenodd"
              d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
              clip-rule="evenodd"
            />
          </svg>
          Administración
        </h3>
        <div class="space-y-2 ml-8">
          <!-- <p class="flex items-center text-gray-700">
            <span class="font-medium mr-2">Tel:</span> 4582-6340
          </p> -->
          <p class="flex items-center">
            <span class="font-medium mr-2 text-gray-700">Mail:</span>
            <a
              href="mailto:administracion.hogar@everfull.com.ar"
              class="text-secondary hover:text-primary font-medium transition-colors duration-300 hover:underline"
            >
              administracion.hogar@everfull.com.ar
            </a>
          </p>
        </div>
      </div>

      <!-- Horario -->
      <div
        class="bg-gradient-to-r from-secondary to-primary text-white p-6 rounded-2xl shadow-medium"
      >
        <h3 class="font-bold text-lg mb-2 flex items-center">
          <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
              clip-rule="evenodd"
            />
          </svg>
          Horario de atención
        </h3>
        <p class="ml-7">Lunes a Viernes de 9 a 18hs.</p>
      </div>
    </div>
    <div
      class="col-span-1 mb-1 pt-10 order-2 px-6 md:px-10 md:border-t-0 border-t-2 border-gray-200 bg-gradient-to-br from-gray-50 to-white animate-fadeInUp"
      style="animation-delay: 0.2s"
    >
      <div class="inline-block mb-6">
        <h1 class="text-3xl md:text-4xl font-bold text-primary mb-2">
          Hacenos tu <span class="text-secondary">consulta</span>
        </h1>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full"
        ></div>
      </div>

      <form (ngSubmit)="onSubmit()" #contactForm="ngForm">
        <!-- Campo Honeypot (invisible para usuarios reales) -->
        <div class="hidden" aria-hidden="true">
          <label>No llene este campo si es una persona</label>
          <input
            type="text"
            name="website"
            [(ngModel)]="honeypot"
            tabindex="-1"
            autocomplete="off"
          />
        </div>

        <!-- Mensaje de error de spam -->
        <div
          *ngIf="spamError"
          class="mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg"
          role="alert"
        >
          <strong class="font-bold">Atención:</strong>
          <span class="block sm:inline"> {{ spamError }}</span>
        </div>

        <div class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-2"
            >Motivo de la consulta <span class="text-red-500">*</span></label
          >
          <select
            required
            [(ngModel)]="motivoConsulta"
            name="motivoConsulta"
            class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
          >
            <option value="" disabled selected>Selecciona un motivo</option>
            <option *ngFor="let reason of reasons" [value]="reason.reason">
              {{ reason.reason }}
            </option>
          </select>
        </div>

        <!-- Selector de productos (solo visible cuando el motivo es "Productos") -->
        <div *ngIf="motivoConsulta === 'Productos'" class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-3">
            Selecciona los productos de tu interés:
          </label>

          <!-- Loading de productos -->
          <div
            *ngIf="loadingProducts"
            class="flex justify-center items-center py-8"
          >
            <div
              class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"
            ></div>
            <span class="ml-2 text-gray-600">Cargando productos...</span>
          </div>

          <!-- Grid de productos -->
          <div
            *ngIf="!loadingProducts && products.length > 0"
            class="grid grid-cols-2 md:grid-cols-4 gap-4"
          >
            <div
              *ngFor="let product of products"
              (click)="toggleProductSelection(product.name)"
              class="relative border-2 rounded-lg p-3 cursor-pointer transition-all duration-300 hover:shadow-lg"
              [class.bg-white]="isProductSelected(product.name)"
              [class.bg-gray-200]="!isProductSelected(product.name)"
              [class.border-primary]="isProductSelected(product.name)"
              [class.border-gray-400]="!isProductSelected(product.name)"
              [class.shadow-lg]="isProductSelected(product.name)"
              [class.shadow-sm]="!isProductSelected(product.name)"
              [class.opacity-100]="isProductSelected(product.name)"
              [class.opacity-40]="!isProductSelected(product.name)"
              [class.scale-105]="isProductSelected(product.name)"
              [class.scale-95]="!isProductSelected(product.name)"
            >
              <!-- Checkbox visual en la esquina superior derecha -->
              <div class="absolute top-2 right-2 z-10">
                <div
                  class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-300"
                  [class.bg-primary]="isProductSelected(product.name)"
                  [class.border-primary]="isProductSelected(product.name)"
                  [class.bg-gray-300]="!isProductSelected(product.name)"
                  [class.border-gray-500]="!isProductSelected(product.name)"
                >
                  <svg
                    *ngIf="isProductSelected(product.name)"
                    class="w-3 h-3 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>

              <!-- Imagen del producto -->
              <div class="flex justify-center mb-2">
                <img
                  [src]="product.imageUrl"
                  [alt]="product.name"
                  class="w-16 h-16 object-contain transition-all duration-300"
                  [class.scale-110]="isProductSelected(product.name)"
                  onerror="this.src='assets/logo-dark.png'"
                />
              </div>

              <!-- Nombre del producto -->
              <div class="text-center">
                <h4
                  class="text-sm font-semibold transition-all duration-300"
                  [class.text-primary]="isProductSelected(product.name)"
                  [class.text-gray-600]="!isProductSelected(product.name)"
                  [class.font-bold]="isProductSelected(product.name)"
                >
                  {{ product.name }}
                </h4>
              </div>
            </div>
          </div>

          <!-- Mensaje si no hay productos -->
          <div
            *ngIf="!loadingProducts && products.length === 0"
            class="text-center py-4 text-gray-500"
          >
            No se pudieron cargar los productos. Puedes describir tu consulta en
            el mensaje.
          </div>

          <!-- Contador de productos seleccionados -->
          <div
            *ngIf="selectedProducts.length > 0"
            class="mt-3 text-sm text-primary"
          >
            <span class="font-medium"
              >Productos seleccionados ({{ selectedProducts.length }}):</span
            >
            <span class="ml-2">{{ selectedProducts.join(", ") }}</span>
          </div>
        </div>

        <div class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-2"
            >Nombre <span class="text-red-500">*</span></label
          >
          <input
            [(ngModel)]="nombre"
            name="nombre"
            type="text"
            placeholder="Ingrese su nombre"
            required
            class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
          />
        </div>

        <div class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-2"
            >Apellidos <span class="text-red-500">*</span></label
          >
          <input
            [(ngModel)]="apellidos"
            name="apellidos"
            type="text"
            placeholder="Ingrese sus apellidos"
            required
            class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
          />
        </div>

        <div class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-2"
            >Correo Electrónico <span class="text-red-500">*</span></label
          >
          <input
            [(ngModel)]="email"
            name="email"
            type="email"
            placeholder="correo@ejemplo.com"
            required
            email
            class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
          />
        </div>

        <div class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-2"
            >Teléfono <span class="text-red-500">*</span></label
          >
          <input
            [(ngModel)]="telefono"
            name="telefono"
            type="number"
            placeholder="Ej: 1123456789"
            required
            pattern="[0-9]{6,20}"
            class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
          />
        </div>

        <div class="w-full mb-4">
          <label class="block text-sm font-medium text-primary mb-2"
            >Mensaje <span class="text-red-500">*</span></label
          >
          <textarea
            [(ngModel)]="mensaje"
            name="mensaje"
            placeholder="Escriba su mensaje aquí..."
            required
            rows="5"
            class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full resize-none"
          ></textarea>
        </div>

        <button
          type="submit"
          [disabled]="!contactForm.form.valid || isLoading"
          class="w-full bg-gradient-to-br from-primary to-blue-900 text-white py-3 px-5 rounded-full text-base font-bold flex items-center justify-center shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <span *ngIf="isLoading" class="mr-2">
            <svg
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </span>
          {{ isLoading ? "Enviando..." : "Enviar" }}
        </button>
      </form>
      <br />
      <div
        *ngIf="mensajeExito"
        class="font-bold text-white rounded-lg bg-green-500 py-2 px-5 text-center mt-5"
      >
        {{ mensajeExito }}
      </div>
    </div>
  </div>
</section>
